/*
Monotype Foundry Platform API
Version 1.0.0

Definition: FamiliesStylesRequest

Properties:
  submissionIds: array (required)
*/

var FamiliesStylesRequest = (function () {
  function validateFamiliesStylesRequest (arg) {
    // Validate submissionIds
    if (!arg.submissionIds) {
      throw new Error('FamiliesStylesRequest.submissionIds: Missing property')
    }
    if (arg.submissionIds && !(Array.isArray(arg.submissionIds))) {
      throw new Error('FamiliesStylesRequest.submissionIds: Wrong type: Got \'' + (typeof arg.submissionIds) + '\', but expected: \'array\'')
    }
  }
  function buildFamiliesStylesRequest (arg) {
    var FamiliesStylesRequest = arg
    // Complete submissionIds
    // Expected Type: array
    FamiliesStylesRequest.submissionIds = FamiliesStylesRequest.submissionIds || []
    return FamiliesStylesRequest
  }
  return {
    validate: validateFamiliesStylesRequest,
    build: buildFamiliesStylesRequest
  }
})()

module.exports = FamiliesStylesRequest
